import React, { useState, useEffect } from "react";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import { API_URI } from "../../helpers";

function Stat({ label, value, sub, color }) {
  return (
    <Card style={{ marginTop: 0 }}>
      <CardBody style={{ textAlign: "center" }}>
        <div style={{ fontSize: 32, fontWeight: 700, color: color || "#1f2937" }}>{value}</div>
        <div style={{ fontSize: 13, color: "#64748B", fontWeight: 600 }}>{label}</div>
        {sub != null && <div style={{ fontSize: 12, color: "#94A3B8" }}>{sub}</div>}
      </CardBody>
    </Card>
  );
}

export default function MessagingDashboard() {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(false);

  function load() {
    setLoading(true);
    fetch(`${API_URI}/dashboard/messaging`)
      .then((r) => r.json())
      .then(setD)
      .finally(() => setLoading(false));
  }
  useEffect(load, []);

  if (!d) return <div style={{ padding: 24 }}>{loading ? "Cargando…" : "Sin datos."}</div>;

  const q = d.queue || {};
  const carts = d.carts || {};
  const fup = d.followup || {};
  const steps = fup.by_step || {};

  return (
    <GridContainer>
      <GridItem xs={12}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
          <h4 style={{ margin: 0 }}>Mensajería</h4>
          <span style={{
            background: d.enabled ? "#16A34A" : "#DC2626", color: "#fff",
            borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 700,
          }}>{d.enabled ? "Motor ON" : "Motor OFF (no envía)"}</span>
          <span style={{ flex: 1 }} />
          <Button size="sm" color="info" onClick={load}>Actualizar</Button>
        </div>
      </GridItem>

      {/* Cola / outbox */}
      <GridItem xs={6} sm={4} md={2}><Stat label="Pendientes" value={q.pending || 0} color="#94A3B8" /></GridItem>
      <GridItem xs={6} sm={4} md={2}><Stat label="Enviando" value={q.sending || 0} color="#3B82F6" /></GridItem>
      <GridItem xs={6} sm={4} md={2}><Stat label="Enviados" value={q.sent || 0} color="#16A34A" /></GridItem>
      <GridItem xs={6} sm={4} md={2}><Stat label="Fallidos" value={q.failed || 0} color="#DC2626" /></GridItem>
      <GridItem xs={6} sm={4} md={2}><Stat label="Cancelados" value={q.canceled || 0} color="#6B7280" /></GridItem>

      {/* Carritos */}
      <GridItem xs={12}><h5 style={{ marginBottom: 4 }}>Recupero de carritos</h5></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Carritos abiertos" value={carts.total_open || 0} /></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Contactados" value={carts.contacted || 0} /></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Recuperados" value={carts.recovered || 0} color="#16A34A" /></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Tasa recupero" value={`${carts.recover_rate || 0}%`} color="#16A34A" /></GridItem>

      {/* Seguimiento automático */}
      <GridItem xs={12}>
        <h5 style={{ marginBottom: 4 }}>Seguimiento automático (WhatsApp + DMs)</h5>
        <div style={{ fontSize: 12, color: "#94A3B8", marginBottom: 4 }}>
          Consultas que quedaron mudas tras la autorespuesta. “Contestaron” = respondieron un toque
          y pasaron a un operador humano.
        </div>
      </GridItem>
      <GridItem xs={6} sm={3}><Stat label="Con seguimiento" value={fup.touched || 0} /></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Contestaron" value={fup.replied || 0} color="#16A34A" /></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Tasa respuesta" value={`${fup.reply_rate || 0}%`} color="#16A34A" /></GridItem>
      <GridItem xs={6} sm={3}><Stat label="Toques en cola" value={fup.pending || 0} color="#94A3B8" /></GridItem>
      <GridItem xs={12} sm={4}>
        <Stat
          label="Toques enviados"
          value={fup.sent || 0}
          sub={`1º ${steps.step1 || 0} · 2º ${steps.step2 || 0} · 3º ${steps.step3 || 0}`}
        />
      </GridItem>

      {/* Envíos por día */}
      <GridItem xs={12}>
        <Card>
          <CardHeader color="info"><span style={{ color: "#fff" }}>Enviados por día (14d)</span></CardHeader>
          <CardBody>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 600 }}>Fecha</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>Email</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>WhatsApp</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>DMs Meta</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(d.by_day || []).length === 0 && (
                  <TableRow><TableCell colSpan={5} style={{ textAlign: "center", color: "#94A3B8" }}>Sin envíos aún.</TableCell></TableRow>
                )}
                {(d.by_day || []).map((row) => (
                  <TableRow key={row.date}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.email || 0}</TableCell>
                    <TableCell>{row.whatsapp || 0}</TableCell>
                    <TableCell>{row.meta_dm || 0}</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>
                      {(row.email || 0) + (row.whatsapp || 0) + (row.meta_dm || 0)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
